const normalizeErrorText = (value: unknown): string | null => {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed || null;
  }

  if (typeof value === 'number' && Number.isFinite(value)) {
    return String(value);
  }

  return null;
};

export const getApiErrorPayload = (error: any) => {
  const responseData = error?.response?.data ?? error?.data ?? {};
  const errorCode = normalizeErrorText(
    responseData?.errorCode ?? responseData?.code ?? responseData?.error_type ?? responseData?.errorType
  );
  const errorMessage = normalizeErrorText(
    responseData?.errorMessage ??
      responseData?.message ??
      responseData?.errorTitle ??
      responseData?.error ??
      responseData?.detail
  );

  return {
    errorCode,
    errorMessage,
    errorDetails: responseData?.errorDetails ?? responseData?.details ?? null,
    status: error?.response?.status ?? error?.status ?? null,
    rawData: responseData,
  };
};

export const getApiErrorMessage = (error: any, fallbackMessage: string) => {
  const payload = getApiErrorPayload(error);

  if (payload.errorMessage) {
    return payload.errorMessage;
  }

  if (typeof error?.message === 'string') {
    const trimmedMessage = error.message.trim();

    if (trimmedMessage) {
      return trimmedMessage;
    }
  }

  return fallbackMessage;
};

export const isApiErrorCode = (error: any, expectedCode: string | string[]) => {
  const { errorCode } = getApiErrorPayload(error);

  if (!errorCode) {
    return false;
  }

  if (Array.isArray(expectedCode)) {
    return expectedCode.includes(errorCode);
  }

  return errorCode === expectedCode;
};
